module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-12-9faaf65b658dace62c4635ca9cbc1326.jpeg";